<div class="container">
  <ng-container *ngIf="fantasyHistory$ | async as fantasyHistory">
    <ng-container *ngIf="fantasyHistory && fantasyHistory.length > 0; else noPlayerHistory">
      <div class="results-container">
        <div class="results-header w-100 d-flex flex-row align-items-center justify-content-between">
          <p class="font-size-14 fw-bold mb-0 text-white">{{ 'fantasy.results.your.pick' | translate }}</p>
          <p class="font-size-14 fw-bold mb-0 text-white">{{ 'fantasy.results.score' | translate }}</p>
        </div>
        <div class="results-list d-flex flex-column">
          <ng-container *ngFor="let item of fantasyHistory">
            <fgb-fantasy-history-list-item [fantasyHistoryItem]="item"></fgb-fantasy-history-list-item>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <ng-template #noPlayerHistory>
      <div class="no-items w-100 text-center border rounded py-4 mt-4">
        <div class="svg svg-info vs-svg ms-auto me-auto" fgbAnimateSvg [inlineSVG]="'assets/images/games/Results.svg'"></div>
        <p class="text-black text-center font-size-14 mt-2 mb-0 text-white">
          {{ 'fantasy.results.placeholder.description' | translate }}
        </p>
      </div>
    </ng-template>
  </ng-container>
</div>
